import { makeStyles } from "@fluentui/react-components";

export const useScopePivotValueDropdownStyles = makeStyles({
    root: {},
    comboBoxListBox: {
        maxHeight: "300px"
    },
    skeletonItem: {
        marginTop: "8px"
    }
});
